"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Format the card input to have spaces every 4 characters
 */
exports.formatCreditCardNumber = function (cardNumber) {
    if (!cardNumber) {
        return '';
    }
    var numbersOnly = cardNumber.replace(/[^\d]/g, '');
    if (numbersOnly.length < 4) {
        return numbersOnly;
    }
    var matches = numbersOnly.match(/\d{1,4}/g);
    if (matches === null) {
        return '';
    }
    return matches.join(' ');
};
/**
 * Insert slash between expiration date month and year
 */
exports.formatExpirationDate = function (expirationDate) {
    if (!expirationDate) {
        return '';
    }
    var numbersOnly = expirationDate.replace(/[^\d]/g, '');
    if (numbersOnly.length < 2) {
        return numbersOnly;
    }
    return numbersOnly.slice(0, 2) + '/' + numbersOnly.slice(2, 4);
};
